module.exports = __webpack_public_path__ + "media/images/teams/logo__8-7e1c9521ce0835d45faaeb3b04da2cfc.svg";